type Coordinates = {
  latitude: number | null;
  longitude: number | null;
};

type CardinalPoints = {
  north: number | null;
  south: number | null;
  east: number | null;
  west: number | null;
};

export const calculateCardinalPoints = (items: Coordinates[], initCenter?: Coordinates) => {
  const cardinalPoints: CardinalPoints = {
    north: null,
    south: null,
    east: null,
    west: null,
  };

  if (items.length === 0 && initCenter) {
    cardinalPoints.north = initCenter.latitude ? initCenter.latitude + 0.01 : null;
    cardinalPoints.south = initCenter.latitude ? initCenter.latitude - 0.01 : null;
    cardinalPoints.east = initCenter.longitude ? initCenter.longitude + 0.01 : null;
    cardinalPoints.west = initCenter.longitude ? initCenter.longitude - 0.01 : null;
  }

  items.forEach(({ latitude, longitude }) => {
    if (!latitude || !longitude) return;

    const { north, south, east, west } = cardinalPoints;
    if (north === null || latitude > north) {
      cardinalPoints.north = latitude;
    }
    if (south === null || latitude < south) {
      cardinalPoints.south = latitude;
    }
    if (east === null || longitude > east) {
      cardinalPoints.east = longitude;
    }
    if (west === null || longitude < west) {
      cardinalPoints.west = longitude;
    }
  });

  return cardinalPoints;
};
